import { v4 as uuid } from 'uuid';
export var CustomDomainStatus;
(function (CustomDomainStatus) {
    CustomDomainStatus["new"] = "new";
    CustomDomainStatus["waiting"] = "waiting";
    CustomDomainStatus["connected"] = "connected";
})(CustomDomainStatus || (CustomDomainStatus = {}));
export var CustomDomainHttpsStatus;
(function (CustomDomainHttpsStatus) {
    CustomDomainHttpsStatus["new"] = "new";
    CustomDomainHttpsStatus["waiting"] = "waiting";
    CustomDomainHttpsStatus["connected"] = "connected";
})(CustomDomainHttpsStatus || (CustomDomainHttpsStatus = {}));
export var CustomDomainDnsStatus;
(function (CustomDomainDnsStatus) {
    CustomDomainDnsStatus["new"] = "new";
    CustomDomainDnsStatus["waiting"] = "waiting";
    CustomDomainDnsStatus["connected"] = "connected";
})(CustomDomainDnsStatus || (CustomDomainDnsStatus = {}));
export class CustomDomain {
    id;
    companyId = null;
    dateCreated = null;
    status = CustomDomainStatus.new;
    dnsStatus = CustomDomainDnsStatus.new;
    httpsStatus = CustomDomainHttpsStatus.new;
    nextScheduledCheck = null;
    timesChecked = 0;
    constructor(id, data) {
        this.id = id || uuid();
        let definedKeys = Object.keys(this).filter((key) => key != "id");
        for (let key in data) {
            let value = data[key];
            let keyIsDefinedOnInstance = definedKeys.includes(key);
            if (keyIsDefinedOnInstance) {
                if (value) {
                    //replace all firebase dates with real dates
                    if (value.seconds && value.toDate) {
                        value = value.toDate();
                    }
                }
                Object.assign(this, { [key]: value });
            }
        }
    }
}
